import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Routes from './routes/Routes';
import { ThemeProvider } from 'lmc-ui-library';
import { initAuth } from 'auth/store/actions';
import { Loader } from 'components/Loader/Loader';
import { RebrandContext } from 'helpers/contexts/rebrandContext';
import VersionCheck from './components/VersionCheck/VersionCheck';

const App: React.FC = () => {
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState<boolean>(false);
  const [newUi, setNewUi] = useState(false);

  useEffect(() => {
    (async () => {
      await dispatch(initAuth());
      setLoaded(true);
    })();
  }, [dispatch]);

  const handleAppVersionChanged = () => {
    if (window && window.location) {
      window.location.reload();
    }
  };

  return (
    <RebrandContext.Provider value={{ newUi: newUi, setNewUi: setNewUi as () => void }}>
      <ThemeProvider
        useFonts={(fonts) => ({
          ...fonts,
          primary: 'var(--primary-font)',
          secondary: 'var(--secondary-font)',
        })}>
        <VersionCheck onVersionChanged={handleAppVersionChanged} />
        {!loaded && <Loader />}
        {loaded && <Routes />}
      </ThemeProvider>
    </RebrandContext.Provider>
  );
};

export default App;
